var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.listTitle,
        "show-filter": true,
        "show-refresh": true,
        "filter-expanded": _vm.displayFilter,
        "refresh-disabled": _vm.activateSpinner,
      },
      on: { "toggle-filter": _vm.toggleFilters, refresh: _vm.reloadData },
    },
    [
      _c(
        "template",
        { slot: "secondaryActions" },
        [
          _c(
            "div",
            { staticClass: "tw-flex tw-gap-2" },
            [
              _c("app-button", {
                attrs: {
                  text: _vm.$t("common.email.email_group_add"),
                  icon: "fa-light fa-plus",
                  variant: "secondary",
                },
                on: { click: _vm.actionAdd },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-collapse",
            {
              staticClass: "mt-3",
              model: {
                value: _vm.displayFilter,
                callback: function ($$v) {
                  _vm.displayFilter = $$v
                },
                expression: "displayFilter",
              },
            },
            [
              _c(
                "div",
                { staticClass: "bg-white border rounded p-3" },
                [
                  _c(
                    "b-row",
                    { staticClass: "g-3 mb-3" },
                    [
                      _c("b-col", { attrs: { sm: "6", lg: "4" } }, [
                        _c(
                          "div",
                          { staticClass: "bg-light border rounded p-3" },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "form-label font-weight-bold text-muted mb-2",
                                attrs: { for: "filter-group-name" },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-solid fa-users mr-2",
                                }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("common.email.group_name")) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("form-write-group-label-input", {
                              attrs: {
                                id: "filter-group-name",
                                inputLabel: _vm.$t("common.email.group_name"),
                              },
                              model: {
                                value: _vm.GroupName,
                                callback: function ($$v) {
                                  _vm.GroupName = $$v
                                },
                                expression: "GroupName",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "gx-2" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("app-button", {
                            attrs: {
                              text: _vm.$t("filter.clr_fltr_field"),
                              icon: "fa-light fa-eraser",
                              variant: "secondary",
                              outline: "",
                              block: true,
                              "aria-label": _vm.$t("filter.clr_fltr_field"),
                              disabled: !_vm.GroupName || _vm.activateSpinner,
                            },
                            on: { click: _vm.clearFilterFields },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("app-button", {
                            attrs: {
                              text: _vm.$t("common.srch"),
                              icon: "fa-light fa-magnifying-glass",
                              variant: "primary",
                              block: true,
                              "aria-label":
                                _vm.$t("common.srch") +
                                " " +
                                _vm.$t("common.email.email_group_list"),
                              loading: _vm.activateSpinner,
                              loadingText: _vm.$t("common.rfrsh"),
                            },
                            on: { click: _vm.onRefresh },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage ml-3 mr-3" },
          [
            _c("b-row", { staticClass: "justify-content-center mb-5" }, [
              _c(
                "div",
                [
                  _vm.activateSpinner
                    ? _c("spinner")
                    : _vm.listItemsEmailGroup.length > 0
                    ? _c("b-table", {
                        key: _vm.refreshKey,
                        staticClass: "table-striped",
                        attrs: {
                          items: _vm.listItemsEmailGroup,
                          fields: _vm.fields,
                          "sort-by": _vm.sortBy,
                          fixed: "",
                          hover: "",
                          selectable: _vm.listItemsEmailGroup.length > 0,
                          "empty-text": _vm.$t("common.security.no_result"),
                        },
                        on: {
                          "update:sortBy": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function ($event) {
                            _vm.sortBy = $event
                          },
                          "row-selected": _vm.onRowClicked,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(GroupName)",
                            fn: function (data) {
                              return [_c("span", [_vm._v(_vm._s(data.value))])]
                            },
                          },
                          {
                            key: "cell(edit)",
                            fn: function (data) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-center d-inline-block py-3 w-100",
                                    on: {
                                      click: function ($event) {
                                        return _vm.actionEdit(
                                          $event,
                                          data.item.IdEmailGroup
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-regular fa-pencil",
                                    }),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(delete)",
                            fn: function (data) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-center d-inline-block py-3 w-100",
                                    on: {
                                      click: function ($event) {
                                        return _vm.actionDelete(
                                          $event,
                                          data.item.IdEmailGroup
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-regular fa-trash",
                                    }),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      })
                    : _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c("span", { staticClass: "noResult" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("common.no_result")) +
                                "\n            "
                            ),
                          ]),
                        ]
                      ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }